import React from "react";
import styles from "./headerGame.module.css";

function HeaderGame({ gameNameTH }) {
  return (
    <div className={styles.head}>
      <h1 className={styles.h1}>{gameNameTH}</h1>
    </div>
  );
}

export default HeaderGame;
